<template>
  <section id="lab-documents-view" class="all-cases-view">
    <div class="container-small-table">
      <div class="listings-navbar">
        <el-row>
          <el-col :lg="7">
            <ul class="d-flex flex-wrap list-items-group-15">
              <li>
                <div class="form-element input-with-icon search-input-lg">
                  <el-input
                    placeholder="SEARCH FOLDER NAME"
                    v-model="search_string"
                    @input="getAutoCompleteCases()"
                    :clearable="true"
                  ></el-input>
                  <span>
                    <img
                      src="@/assets/images/icons/search-icon-with-bg-red.svg"
                      alt="icon"
                      class="img-fluid icon"
                    />
                  </span>
                </div>
              </li>
            </ul>
          </el-col>
          <el-col :lg="17">
            <ul
              class="d-flex flex-wrap justify-content-end list-items-group-15"
            >
              <li v-if="hasPermission('lab_documents', 'add')">
                <el-button
                  class="btn button-with-icon"
                  @click="dialogVisible = true"
                >
                  <span class="mr-8">
                    <img
                      src="@/assets/images/icons/plus-icon.svg"
                      alt="icon"
                      class="inactive"
                    />
                    <img
                      src="@/assets/images/icons/plus-icon-white.svg"
                      alt="icon"
                      class="active"
                    />
                  </span>
                  <span>Create Folder</span>
                </el-button>
              </li>
              <li>
                <el-button
                  class="btn button-with-icon"
                  :class="foldersView == 'list' ? 'active' : ''"
                  @click="foldersView = 'list'"
                >
                  <span>
                    <img
                      src="@/assets/images/icons/lab-documents/listing-inactive.svg"
                      alt="icon"
                      class="inactive"
                    />
                    <img
                      src="@/assets/images/icons/lab-documents/listing-active.svg"
                      alt="icon"
                      class="active"
                    />
                  </span>
                </el-button>
              </li>
              <li>
                <el-button
                  class="btn button-with-icon"
                  :class="foldersView == 'grid' ? 'active' : ''"
                  @click="foldersView = 'grid'"
                >
                  <span>
                    <img
                      src="@/assets/images/icons/lab-documents/grid-listing-inactive.svg"
                      alt="icon"
                      class="inactive"
                    />
                    <img
                      src="@/assets/images/icons/lab-documents/grid-listing-active.svg"
                      alt="icon"
                      class="active"
                    />
                  </span>
                </el-button>
              </li>
            </ul>
          </el-col>
        </el-row>
      </div>
    </div>

    <div class="container-small-table" style="padding-top: 0">
      <div
        v-loading="loading"
        element-loading-text="Loading Files..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <div v-if="getAllCategories.data && getAllCategories.data.length">
          <div class="grid-view-block" v-if="foldersView == 'grid'">
            <div class="grid-scroll">
              <div class="single-grid-view-block">
                <div
                  v-for="(category, index) of getAllCategories.data"
                  :key="index"
                  class="single-grid-view-block-col"
                >
                  <router-link
                    :to="{
                      name: 'LabCategoryFiles',
                      params: {
                        folder_id: category._id,
                        folder_name: category.name,
                      },
                      query: {
                        ...this.$route.query,
                        redirectRoute: this.$route.name,
                      },
                    }"
                  >
                    <div class="icon-block">
                      <img
                        src="@/assets/images/icons/lab-documents/folder.svg"
                        alt="folders"
                      />
                    </div>
                    <div class="content">
                      <h4 class="title">{{ category.name }}</h4>
                    </div>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
          <div
            class="primary-content-view-new"
            v-else-if="foldersView == 'list'"
          >
            <div
              class="listings listings__table listings__all-cases"
              id="all-cases-listings"
            >
              <el-table
                :data="getAllCategories.data"
                height="calc(100vh - 200px)"
              >
                <el-table-column prop="name" label="NAME" min-width="285">
                  <template v-slot="scope">
                    <div id="name-accession">
                      <span class="order-files ml-5">
                        <img
                          src="@/assets/images/icons/lab-documents/folder.svg"
                          alt="icon"
                        />
                      </span>
                      <span class="folder-name cursor">
                        <router-link
                          class="route-navigation"
                          :to="{
                            name: 'LabCategoryFiles',
                            params: {
                              folder_id: scope.row._id,
                              folder_name: scope.row.name,
                            },
                            query: {
                              ...this.$route.query,
                              redirectRoute: this.$route.name,
                            },
                          }"
                        >
                          {{ scope.row.name }}
                        </router-link>
                      </span>
                    </div>
                  </template>
                </el-table-column>

                <el-table-column
                  prop="created_at"
                  label="DATE CREATED"
                  min-width="300"
                >
                  <template #default="scope">
                    <div v-if="scope.row.created_at" class="d-flex">
                      <div class="date pr-10">
                        {{
                          momentWithTimezone(scope.row.created_at, "MM-DD-yyyy")
                        }}
                      </div>
                    </div>
                  </template>
                </el-table-column>

                <el-table-column prop="action" label="Actions" width="90">
                  <template v-slot="scope">
                    <ul class="listings__action-buttons">
                      <router-link
                        :to="{
                          name: 'LabCategoryFiles',
                          params: {
                            folder_id: scope.row._id,
                            folder_name: scope.row.name,
                          },
                          query: {
                            ...this.$route.query,
                            redirectRoute: this.$route.name,
                          },
                        }"
                      >
                        <li>
                          <el-button class="view-button">
                            <img
                              class="action-active"
                              src="@/assets/images/icons/actions/view-icon.svg"
                              alt="icon"
                            />
                            <img
                              class="action-inactive"
                              src="@/assets/images/icons/actions/view-inactive.svg"
                              alt="icon"
                            />
                          </el-button>
                        </li>
                      </router-link>
                    </ul>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
          <div
            class="listings listings__pagination"
            v-if="this.getAllCategories && this.getAllCategories.total > 10"
          >
            <el-pagination
              v-model:currentPage="page"
              v-model:page-size="pageSize"
              :page-sizes="[10, 25, 50, 100]"
              layout=" prev, pager, next, jumper, sizes ,total"
              :total="getAllCategories.total"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            />
          </div>
        </div>
        <div class="no-data-block" v-else>
          <div class="bg-image">
            <img
              src="@/assets/images/backgrounds/no-data-img.png"
              class="bg-image"
              alt="No data Background"
            />
            <div class="no-data-content">
              <h3>No data</h3>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="default-modal">
      <el-dialog
        v-model="dialogVisible"
        width="30%"
        :before-close="handleClose"
        v-loading="modalLoading"
      >
        <div class="dialog-header">
          <span class="header-part"> Create Folder </span>
          <el-button
            size="medium"
            class="el-white"
            type="info"
            plain
            @click="handleClose"
          >
            <img src="@/assets/images/icons/cases/close-btn.svg" alt="icon" />
          </el-button>
        </div>
        <div class="popup-date pb-0">
          <div class="popup-text-areas">
            <el-form
              ref="form"
              :model="form"
              @keyup.enter.prevent="createNewFolder('form')"
            >
              <label type="Name">
                <el-input v-model="form.name"></el-input>
              </label>
              <p
                class="err"
                v-if="
                  getFolderCreateValidationErrors &&
                  getFolderCreateValidationErrors.name
                "
              >
                {{ getFolderCreateValidationErrors.name }}
              </p>
              <p
                class="err"
                v-if="
                  getFolderCreateValidationErrors &&
                  getFolderCreateValidationErrors.critical_error
                "
              >
                {{ getFolderCreateValidationErrors.critical_error }}
              </p>
            </el-form>
          </div>
          <div class="dialog-footer">
            <el-button
              class="blue-save-button"
              @click="createNewFolder"
              v-loading="modalLoading"
              >CREATE</el-button
            >
          </div>
        </div>
      </el-dialog>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";
import FilterHelper from "@/mixins/FilterHelper";
import {
  successNotification,
  errorNotification,
} from "@/helpers/notifications";

export default {
  name: "",
  components: {},
  mixins: [UserPermissionsHelper, FilterHelper],

  data() {
    return {
      scrollPosition: null,
      foldersView: "grid",
      loading: false,
      form: {
        name: "",
      },
      modalLoading: false,
      dialogVisible: false,
      page: 1,
      pageSize: 25,
      search_string: "",
      orderBy: "created_at",
      orderType: "DESC",
    };
  },
  computed: {
    ...mapGetters("labDocuments", [
      "getAllCategories",
      "getFolderCreateStatus",
      "folderCreateValidationErrors",
      "getFolderCreateValidationErrors",
    ]),
    ...mapGetters("errors", ["getErrors"]),
  },
  mounted() {
    this.setQueryParamsData();
    this.fetchAllFiles();
    window.addEventListener("scroll", this.updateScroll);
  },
  methods: {
    handleClose() {
      this.dialogVisible = false;
      this.form = "";
      this.$store.commit("labDocuments/setFolderCreateValidationErrors", null, {
        root: true,
      });
    },
    async updateScroll() {
      this.scrollPosition = window.scrollY;
    },
    getAutoCompleteCases() {
      setTimeout(() => {
        this.page = 1;
        this.fetchAllFiles();
      }, 600);
    },
    setQueryParamsData() {
      this.page = this.$route.query.selectedPage
        ? parseInt(this.$route.query.selectedPage)
        : 1;
      this.pageSize = this.$route.query.selectedPageSize
        ? parseInt(this.$route.query.selectedPageSize)
        : 25;
      if (this.$route.query.selectedString) {
        this.search_string = this.$route.query.selectedString;
      }
    },
    updateQueryParams(params) {
      let selectedParams = {
        selectedPage: params.page,
        selectedString: params.search_string,
        selectedPageSize: params.limit,
      };
      this.updateQueryParam(this.$route.name, selectedParams);
    },

    async createNewFolder() {
      this.modalLoading = true;
      await this.$store.dispatch("labDocuments/createFolder", this.form);
      if (this.getFolderCreateStatus) {
        successNotification("New Folder Created Successfully");
        this.form = "";
        this.dialogVisible = false;
        window.location.reload();
      } else {
        if (!this.getErrors || this.getError) {
          errorNotification("Error while creating New Case");
        }
      }
      this.modalLoading = false;
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.page = 1;

      this.fetchAllFiles();
    },
    handleCurrentChange(page) {
      this.page = page;

      this.fetchAllFiles();
    },
    prepareParams() {
      const params = {
        page: this.page,
        limit: this.pageSize,
        order_by: this.orderBy || "created_at",
        order_type: this.orderType || "DESC",
      };
      if (this.search_string) {
        params.search_string = this.search_string;
      }
      return params;
    },
    async fetchAllFiles() {
      try {
        this.loading = true;
        let params = this.prepareParams();
        await this.$store.dispatch("labDocuments/fetchCategories", params);
        this.updateQueryParams(params);
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style lang="scss">
#lab-documents-view {
  .breadcrumbs {
    padding: 5px 0 15px;
    .el-breadcrumb__item {
      .el-breadcrumb__inner {
        color: #273480;
        text-transform: uppercase;
        font-size: 14px;
      }
      .el-breadcrumb__separator {
        color: #000000;
      }
    }
  }
  .stickyNavbar {
    padding-bottom: 5px !important;
    .container-small-table {
      padding-top: 0;
      padding-bottom: 5px;
    }
  }
  .order-files {
    img {
      position: relative;
      top: 5px;
    }
  }
  .folder-name {
    font-size: 14px;
    font-weight: 600;
    padding-left: 10px;
    .route-navigation {
      &:visited,
      :focus,
      :active,
      :hover {
        text-decoration: none;
        outline: none;
        color: #0000ee;
      }
    }
  }
  .grid-view-block {
    margin-bottom: 15px;
    height: calc(100vh - 200px);
    overflow: auto;
    .grid-scroll {
      .single-grid-view-block {
        display: grid;
        grid-template-columns: repeat(7, 12.5%);
        -moz-column-gap: 15px;
        column-gap: 15px;
        row-gap: 20px;

        @media (min-width: 1200px) and (max-width: 1450px) {
          grid-template-columns: repeat(6, 15.55%);
          -moz-column-gap: 15px;
          column-gap: 10px;
          row-gap: 30px;
        }
        @media (min-width: 1600px) {
          display: grid;
          grid-template-columns: repeat(8, 11.3%);
          -moz-column-gap: 15px;
          column-gap: 15px;
          row-gap: 20px;
        }

        .single-grid-view-block-col {
          background: #ffffff;
          border: 1.28012px solid #e0e0e0;
          border-radius: 3.84035px;
          padding: 10px;
          .icon-block {
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            img {
              width: 60px;
              height: 60px;
              padding: 0.5rem 0;
            }
            .action-buttons {
              .folder-btn {
                border: none;
                padding: 0;
                &:hover {
                  border: none;
                  background: transparent;
                }
                img {
                  width: 35px;
                  height: 35px;
                  padding: 0;
                }
              }
            }
          }
          .content {
            padding-top: 1rem;

            h4 {
              font-size: 15px;
              color: #25213b;
              font-weight: 500;
              // white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
            .sub-text {
              font-size: 14px;

              color: #08145c;
              font-weight: 500;
              font-size: 14px;
              display: flex;
              justify-content: space-between;
              font-weight: 500;
              padding: 0.5rem 0;
              .file-size {
                padding: 1.5rem 0 0.5rem;
              }
            }
          }
        }
      }
    }
  }
  .no-data-block {
    min-height: 400px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #fff;
    margin-top: 10px;
    text-align: center;
    padding: 15px;
    .bg-image {
      text-align: center;
      .bg-image {
        width: 350px;
      }
    }
    .no-data-content {
      display: flex;
      align-items: center;
      justify-content: center;
      column-gap: 20px;
      margin-top: 55px;

      h3 {
        text-transform: uppercase;
        font-size: 22px;
        color: #bf1b39;
        padding-right: 5px;
      }
    }
  }
}
</style>
